import React, { useContext } from 'react';

import PageContext from '../../Context/PageContext';
import { Rnd } from 'react-rnd';

import $ from "jquery";
import { calcItemPositionByMoveCard, calcMoveCardPosition, calcPosition, deleteItemUtil } from '../../Util/ElemUtil';
import { Button } from '@blueprintjs/core';
import { isMobile } from 'react-device-detect';
import { createAddCropCadreElementAction, createMoveElementAction } from '../../history/element.history';
import { log } from 'console';

const MoveCard = (props: any) => {

  const { zoomValue, setZoomValue, selectedItem, objItems, history, selectedItemIsLock,
    removeItem, setSelectedItem, setOpenAbsoluteMenuSection, addItem
  } = useContext(PageContext);

  const rndCloneRef = React.useRef<Rnd | null>(null);
  const [onOverlap, setOnOverlap] = React.useState<any>(() => {
    return {
      id: null, element: null,
      back: { src: null, width: null, height: null, transform: null },
      new: { src: null, text: null, sizePX: { width: null, height: null }, sizePourcent: { width: null, height: null } }
    }
  });

  const val = props.val;

  //devrait etre calculé par rapport au zoom ??
  const maxWidthORHeightCorner = isMobile ? 150 : 100;
  const sizeMoveCard = isMobile ? 30 / zoomValue : 30 / zoomValue;

  React.useEffect(() => {
    val.rndClone = rndCloneRef;

  }, [])

  function onDragElement(e: any, position: any) {
    //le param scale permet gérer la vitesse du drag, mais pose des problèmes de position
    //le fait de le remettre à 1 à la fin du drag resoud le pb

    if (selectedItem != null) {

      //a t on vraiment besoin de item et selected, on peut utiliser val ?? tester impact
      var item = objItems.find(item => item.id === selectedItem.id);

      var calcPositionIem = calcItemPositionByMoveCard(position, val, zoomValue, "movecard");
      var pos = { x: calcPositionIem.x, y: calcPositionIem.y };

      if (item.type == "text-element" && item.rotate != null && (item.rotate == 90 || item.rotate == 270)) {
        //si il y a rotate, l'update de la position de l'item, doit etre celle sans rotate (car rotate est un element transform)
        let article = $('#' + selectedItem.id)!.find("div");
        let calc2 = rotate90(calcPositionIem.x, calcPositionIem.y, article.height(), article.width());
        pos = { x: calc2.x, y: calc2.y }
        item.rnd.current.updatePosition({ x: calc2.x, y: calc2.y });
      }
      else {
        item.rnd.current.updatePosition({ x: calcPositionIem.x, y: calcPositionIem.y });
      }

      let cloneDiv = $("#clone-" + selectedItem!.id);
      cloneDiv.find("div[class^='corner-resize-']").hide();
      cloneDiv.css({ top: calcPositionIem.y, left: calcPositionIem.x, width: item.wdith, height: item.height, position: 'absolute' });

      $("#stylo-" + selectedItem!.id).hide();

      if (item.type == 'image-element' && item.crop == null) {
        //console.log(getElementCenter(pos, { width: item.width, height: item.height}))
        handleOverlap(item, getElementCenter(pos, { width: item.width, height: item.height }));
      }


    }
  }

  function getElementCenter(position: any, size: any) {
    return {
      x: Math.round(position.x + size.width / 2),
      y: Math.round(position.y + size.height / 2)
    };
  }

  function rotate90(x: any, y: any, width: any, height: any) {
    const cx = x + width / 2;
    const cy = y + height / 2;

    return {
      x: cx - height / 2,
      y: cy - width / 2,
      width: height,
      height: width,
    };
  }

  function onDragElementStop(e: any, position: any) {

    var calcPositionIem = calcItemPositionByMoveCard(position, val, zoomValue, "movecard");

    var backPosition = { x: val.x, y: val.y, width: val.width, height: val.height, zoomValue, crop: cloneCrop(val.crop) }
    var backPositionForCadre = { x: val.x, y: val.y, width: position.node.offsetWidth, height: position.node.offsetHeight, zoomValue }


    if (val.type == "text-element" && val.rotate != null && (val.rotate == 90 || val.rotate == 270)) {
      //si il y a rotate, l'update de la position de l'item, doit etre celle sans rotate (car rotate est un element transform)
      let article = $('#' + selectedItem.id)!.find("div");
      let calc2 = rotate90(calcPositionIem.x, calcPositionIem.y, article.height(), article.width());
      val.x = calc2.x; val.y = calc2.y;
    }
    else {
      val.x = calcPositionIem.x;
      val.y = calcPositionIem.y;
    }

    if (val.width < maxWidthORHeightCorner || val.height < maxWidthORHeightCorner)
      $("#clone-" + selectedItem!.id).find(".corner-resize-bottomLeft").show();
    else
      $("#clone-" + selectedItem!.id).find("div[class^='corner-resize-']").show();

    /**/var calcPositionStylo = calcItemPositionByMoveCard(position, val, zoomValue, "stylocard");
    $("#stylo-" + selectedItem!.id).show();
    $("#stylo-" + selectedItem!.id).css('top', calcPositionStylo.y);
    $("#stylo-" + selectedItem!.id).css('left', calcPositionStylo.x);

    if (onOverlap.id != null) {

      var itemCropCadre = onOverlap.element;
      var initCropCadre = cloneCropCadre(itemCropCadre.cropCadre);
      var initSrc = itemCropCadre.src; var initText = itemCropCadre.text;
      //change saved item src, change DOM too
      itemCropCadre.src = onOverlap.new.src;
      //on récupère l'info si l'image est upload ou non
      itemCropCadre.text = onOverlap.new.text;

      //dans le cas où on ajoute une nouvelle image dans un cadre élément qui contenait déjà une nouvelle image
      //on réinitialise les valeurs de cropCadre
      if (itemCropCadre.cropCadre.isPushImg) {
        itemCropCadre.cropCadre = {
          sizePX: onOverlap.new.sizePX != null ? onOverlap.new.sizePX : { width: null, height: null },
          sizePourcent: onOverlap.new.sizePourcent != null ? onOverlap.new.sizePourcent : { width: null, height: null },
          transform: "translate(0px, 0px)",
          translate: { x: 0, y: 0 },
        }
      }
      else {
        itemCropCadre.cropCadre.sizePX = onOverlap.new.sizePX;
        itemCropCadre.cropCadre.sizePourcent = onOverlap.new.sizePourcent;
      }

      itemCropCadre.cropCadre.isPushImg = true;

      deleteItemUtil(null, { removeItem, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection });

      //history for crop cadre
      var actionCrop = createAddCropCadreElementAction(
        itemCropCadre,
        val,
        { removeItem, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection, addItem },
        { ...backPositionForCadre, cropCadre: initCropCadre, initSrc: initSrc, initText: initText },
        { x: position.x, y: position.y, width: position.node.offsetWidth, height: position.node.offsetHeight, zoomValue: zoomValue, cropCadre: cloneCropCadre(itemCropCadre.cropCadre), initSrc: itemCropCadre.src, initText: itemCropCadre.text }
      );

      history.add(actionCrop);

    }

    if (onOverlap.id == null) {

      //history for crop cadre
      var action = createMoveElementAction(
        val,
        backPosition,
        { x: val.x, y: val.y, width: val.width, height: val.height, zoomValue, crop: cloneCrop(val.crop) }
      );

      history.add(action);
    }

  }

  function handleOverlap(item: any, xy: any) {
    var main = document.querySelector("#" + item.id); // current dragged or resized node
    var targetRect = main?.getBoundingClientRect();

    //il faudra que target soit la position de la souri

    objItems.forEach((element) => {
      if (element.type == 'cadre-element') {

        //si on est dans une autre intersection en cours, on peut pas entrer dans une nouvelle ! && onOverlap.id != null 
        //if (haveIntersection(document.querySelector("#" + element.id)?.getBoundingClientRect(), targetRect) && onOverlap.id == null) {
        //dans textElement on récupère la position de la souri qui est dans un reférentiel globale, alors que la on travaille avec les position dans Editor
        if (isMouseInside(element, xy) && onOverlap.id == null) {

          var sourceImage = item.src;

          //ici on récupère la taille de l'image pour initialiser les valeurs de crop
          //car quand c'est carré, c'est facile, mais si ratio != 1:1, il faut calculer les tailles

          var imgWidth = getIntSize(item.width);
          var imgHeight = getIntSize(item.height);
          //on prend le minum, qui servira de référence 100%

          var h = null; var w = null; var hPourcent = null; var otherPourcent = null; var sizePX = null; var sizePourcent = null;
          var ratio = null;
          //si taille égale, on peut laisser gérer avec 100% et la taille de élément par défaut
          //la taille plus petite est celle qu'on adapte à element
          //la partie ratio gère le cas de cadre-element pas 1:1
          if (imgWidth < imgHeight) {
            w = getIntSize(element.width);
            h = imgHeight / imgWidth * w;
            //multiplier par le ratio de hateur de l'image car pas forcément carré
            ratio = getIntSize(element.width) / getIntSize(element.height);
            otherPourcent = (imgHeight / imgWidth * 100 * ratio).toFixed(3) + '%'
            sizePX = { width: w, height: h }
            sizePourcent = { width: "100%", height: otherPourcent }
          }
          //la partie ratio gère le cas de cadre-element pas 1:1
          else if (imgWidth > imgHeight) {
            h = getIntSize(element.height);
            w = imgWidth / imgHeight * h;
            //multiplier par le ratio de longueur de l'image car pas forcément carré
            ratio = getIntSize(element.height) / getIntSize(element.width);
            otherPourcent = (imgWidth / imgHeight * 100 * ratio).toFixed(3) + '%';

            sizePX = { width: w, height: h }
            sizePourcent = { width: otherPourcent, height: "100%" }
          }
          //si l'image est carré 1:1, on recalcul si finalement element dans lequel on insert est pas carré
          else {

            w = getIntSize(element.width);
            h = getIntSize(element.height);

            var maxWH = Math.max(w, h);

            //w same height
            sizePX = { width: maxWH, height: maxWH }
            //on gère le cas de la taille de élément
            //si 1:1 on laisse
            //si 1:2 hauteur:largeur, alors on set w à 100% et h pourcentage du ratio w/h
            //si 2:1, alors on set h à 100% et w à pourcentage du ratio h/W
            if (h < w) sizePourcent = { width: "100%", height: w / h * 100 + "%" }
            else if (h > w) sizePourcent = { width: h / w * 100 + "%", height: "100%" }
            //else sizePourcent = { width: null, height: null }
            //on met 100%
            else sizePourcent = { width: "100%", height: "100%" }
          }


          //on stocke les anciennes valeurs de crop-cadre
          //on stock un state du style onOverlap
          //pour eviter de rechecker tout et tout
          if (onOverlap.id != element.id && sizePX != null) {

            //si on a pas l'image par défaut et qu'il y a eu une image push, alors pour la taille, il faut aller chercher les infos dans cropCadre
            var tempWidth = element.cropCadre != null && element.cropCadre.isPushImg ? element.cropCadre.sizePourcent.width : element.width;
            var tempHeight = element.cropCadre != null && element.cropCadre.isPushImg ? element.cropCadre.sizePourcent.height : element.height;
            var tempTransform = element.cropCadre != null && element.cropCadre.isPushImg ? element.cropCadre.transform : "translate(0px, 0px)";

            //attention si problème avec les tailles, c'est ici quand on set en jquery la taille
            //etre attentif aux relicats !
            //console.log(tempWidth)
            //console.log(tempHeight)
            //la taille de l'ancien se définit comme suit :
            // - si il y avait déjà
            setOnOverlap({
              element: element, id: element.id,
              back: { src: element.src, width: tempWidth, height: tempHeight, transform: tempTransform },
              new: { src: sourceImage, text: item.text, sizePX: sizePX, sizePourcent: sizePourcent }
            });

            //on stocke les nouvelles et on applique comme c'est le cas
            //on change la src du crop temporairement en jquery pour que ça visible
            //$("#img-" + element.id).attr('src', 'http://localhost:3000/studio' + sourceImage);
            $("#img-" + element.id).attr('src', val.text === 'upload' ? sourceImage : process.env.REACT_APP_PUBLIC_URL + sourceImage);
            if (sizePX.width != null) $("#img-" + element.id).css('width', sizePourcent.width);
            if (sizePX.height != null) $("#img-" + element.id).css('height', sizePourcent.height);
            //on choisit de ne pas hériter du transform de l'image précédemment incluse, on set à 0
            $("#img-" + element.id).css('transform', "translate(0px, 0px)");
          }

        }
        //si onOverlap id vaut celui-ci mais qu'on est plus dans intersection => on libère onOverlap
        //else if (onOverlap.id == element.id && !haveIntersection(document.querySelector("#" + element.id)?.getBoundingClientRect(), targetRect)) {
        else if (onOverlap.id == element.id && !isMouseInside(element, xy)) {
          //si on passe la, c'est qu'il y a avait intersection dans le déplacement en cours, mais que l'on est sorti
          //raz de onOverlap
          //$("#img-" + element.id).attr('src', 'http://localhost:3000/studio' + onOverlap.back.src);
          $("#img-" + element.id).attr('src', startsWithHttps(onOverlap.back.src) ? onOverlap.back.src : process.env.REACT_APP_PUBLIC_URL + onOverlap.back.src);
          if (onOverlap.back.width != null) $("#img-" + element.id).css('width', onOverlap.back.width);
          if (onOverlap.back.height != null) $("#img-" + element.id).css('height', onOverlap.back.height);
          if (onOverlap.back.transform != null) $("#img-" + element.id).css('transform', onOverlap.back.transform);

          //on ajoute une bordure sur cadre element

          setOnOverlap({
            id: null, element: null,
            back: { src: null, width: null, height: null },
            new: { src: null, text: null, sizePX: { width: null, height: null }, sizePourcent: { width: null, height: null } }
          });

        }
      }

    });
  }

  function cloneCrop(crop: any) {
    if (crop == null) return null;

    return {
      cropPart: { ...crop.cropPart },
      fullImage: { ...crop.fullImage },
      isCrop: crop.isCrop
    };

  }

  function cloneCropCadre(data: any) {
    if (data == null) return null;

    return {
      sizePX: {
        width: data.sizePX?.width,
        height: data.sizePX?.height
      },

      sizePourcent: {
        width: data.sizePourcent?.width,
        height: data.sizePourcent?.height
      },

      transform: data.transform,

      translate: {
        x: data.translate?.x,
        y: data.translate?.y
      },

      isPushImg: data.isPushImg
    };
  }

  function startsWithHttps(str: any) {
    return typeof str === "string" && str.startsWith("https://");
  }

  function getIntSize(size: any) {
    if (typeof size === 'string' && size.includes("px"))
      return parseInt(size.replace("px", ""))
    else return size
  }

  function isMouseInside(target: any, mouse: any) {

    return (
      mouse.x >= target.x &&
      mouse.x <= target.x + getIntSize(target.width) &&
      mouse.y >= target.y &&
      mouse.y <= target.y + getIntSize(target.height)
    );
  }


  return (
    <Rnd
      id={'movecard-' + val.id}
      ref={rndCloneRef}
      default={{
        x: calcMoveCardPosition(null, val, zoomValue, null, null, "movecard").x,
        y: calcMoveCardPosition(null, val, zoomValue, null, null, "movecard").y,
        width: sizeMoveCard,
        height: sizeMoveCard,
      }}
      style={{ visibility: (selectedItemIsLock ? 'hidden' : 'visible'), padding: 15, borderRadius: '50%', backgroundColor: 'white', boxShadow: 'rgba(57, 76, 96, 0.15) 0px 0px 4px 1px, rgba(43, 59, 74, 0.3) 0px 0px 0px 1px', zIndex: 999999 }}
      onDrag={(e, d) => { onDragElement(e, d) }}
      onDragStop={(e, d) => { onDragElementStop(e, d) }}
      scale={zoomValue}
      enableResizing={{ top: false, right: false, bottom: false, left: false, topRight: false, bottomRight: false, bottomLeft: false, topLeft: false }}
    >
      <img className="img-move-card" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/move.svg"}></img>
    </Rnd>
  );
};

export default MoveCard;